export default "__VITE_ASSET__BOV7aSLB__"